import logo from "@/assets/mbm-logo.png";

// MBM monogram wordmark. Defaults to a compact header size.
export default function Logo({ className = "h-6 w-auto" }) {
  return (
    <img
      src={logo}
      alt="MBM — Mind Before Markets"
      className={className}
      draggable={false}
      data-testid="mbm-logo"
    />
  );
}
